var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    {
      class: _vm.opened ? "pl-" + _vm.paddingLeft : "pl-0",
      attrs: { dense: "" }
    },
    [
      _vm._l(_vm.nodes, function(node, idx) {
        return [
          node.children && node.children.length && node.show
            ? _c(
                "v-list-group",
                {
                  key: idx,
                  class: "ma-0 pa-0",
                  attrs: { color: "white" },
                  on: {
                    click: function() {
                      return _vm.redirect(node.link)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function() {
                          return [
                            node.icon
                              ? _c(
                                  "v-list-item-action",
                                  [_c("v-icon", [_vm._v(_vm._s(node.icon))])],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "v-list-item-content",
                              { staticClass: "mx-0 pa-0" },
                              [
                                _c(
                                  "v-list-item-title",
                                  {
                                    class: "ma-0 pa-0 overline " + node.cssClass
                                  },
                                  [_vm._v(" " + _vm._s(node.text) + " ")]
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c("main-nav", {
                    class: "ma-0 pa-0",
                    attrs: {
                      nodes: node.children,
                      "padding-left": 4,
                      opened: _vm.opened
                    }
                  })
                ],
                1
              )
            : node.show
            ? _c(
                "v-list-item",
                {
                  key: idx,
                  class: _vm.$route.path.includes(node.link)
                    ? node.cssClass + " active-item"
                    : node.cssClass + " not-active-item",
                  attrs: { link: "", color: "cyan" },
                  on: {
                    click: function() {
                      return _vm.redirect(node.link)
                    }
                  }
                },
                [
                  node.icon
                    ? _c(
                        "v-list-item-action",
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                color: _vm.$route.path.includes(node.link)
                                  ? "green"
                                  : ""
                              }
                            },
                            [_vm._v(_vm._s(node.icon))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        {
                          class: {
                            "light-green--text": _vm.$route.path.includes(
                              node.link
                            ),
                            overline: true
                          }
                        },
                        [_vm._v(_vm._s(node.text))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }